function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.47504 2H20.5205C21.3361 2 22 2.64557 22 3.44226V20.5572C22 21.3539 21.3361 22.0006 20.5205 22.0006H3.47504C2.66113 22.0006 2 21.3539 2 20.5572V3.44226C2 2.64557 2.66113 2 3.47504 2ZM16.0771 19.0427H19.0433V13.8081C19.0433 11.2375 18.4882 9.26131 15.4843 9.26131C14.0414 9.26131 13.0736 10.0524 12.6781 10.803H12.637V9.49799H9.79355V19.0427H12.7564V14.322C12.7564 13.0764 12.992 11.8703 14.5359 11.8703C16.0582 11.8703 16.0771 13.2942 16.0771 14.4009V19.0427ZM6.44901 8.19406C5.49621 8.19406 4.72785 7.42348 4.72785 6.47346C4.72785 5.52399 5.49621 4.75341 6.44901 4.75341C7.39793 4.75341 8.16795 5.52399 8.16795 6.47346C8.16795 7.42348 7.39793 8.19406 6.44901 8.19406ZM7.93294 19.0427H4.96342V9.49799H7.93294V19.0427Z",
  fill: "#EC404A"
});

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.52d90c0f.svg";
export { ForwardRef as ReactComponent };